<script>
    import { map, zone_selected, magnify_levels, current_magnify_level } from "../store";
    import ZoneLocationButton from "./button_zone_location.svelte";
    import ZoneTextButton from "./button_zone_text.svelte";
    import Overlay from "./overlay.svelte";
    import CloseLarge from "carbon-icons-svelte/lib/CloseLarge.svelte";
    export let open;

    const close = () => {
        open = false
    }

    const selectZone = (zone) => {
        $zone_selected = zone;

        let shift = $map.find(x=>x.name == zone).shift_3D;
        let scale = $magnify_levels[$current_magnify_level];
        if(scale == 1)
            document.getElementById('pinned-map').style.transform = `${shift} scale(${scale})`;
        else
        {
            shift = shift.replace("translate(", "").replace(")", '').trim().split(',');
            let x = parseFloat(shift[0].replace('%', ""));
            let y = parseFloat(shift[1].replace('%', ""));

            let _x = 50 - x;
            _x = _x * scale;
            _x = 50 - _x;

            let _y = 50 - y;
            _y = _y * scale;
            _y = 50 - _y;

            document.getElementById('pinned-map').style.transform = `translate(${_x}%,${_y}%) scale(${scale})`;
        }

        close();
    }
</script>

{#if open}
<div class="model-container">
    <Overlay _click={close}/>
    <div class='model-frame'>
        <img src='./assets/images/model_frame.png' alt/>
        <div class='close-button' on:click={close}><CloseLarge size={32}/></div>
        <div class='map-container-wrapper'>
            <div class='map-container'>
                <div class='location-container'>
                    <img src='./assets/images/map_numbered_3d.png'/>
                    {#each $map as zone}
                        <ZoneLocationButton
                            position = {zone.position_3D}
                            dimension = {zone.dimension_3D}
                            _click={() => selectZone(zone.name)}
                        />
                    {/each}
                </div>
                <div class='zone-select-text-buttons'>
                    {#each $map as zone}
                        <ZoneTextButton 
                            title={zone.title}
                            zone={zone.name}
                            _click={() => selectZone(zone.name)}
                        />
                    {/each}
                </div>
            </div>
        </div>
    </div>
</div>
{/if}

<style lang="scss">
    .model-container{
        display: flex;
        position: absolute;
        top: 0; /* idk why but this solves */
        left: 0;
        width: 100%;
        height: 100%;
        max-height: 100svh;
        align-items: center;
        justify-content: center;
        z-index: 2;

        .model-frame{
            width: 100%;
            height: fit-content;
            position: relative;
            max-height: 95svh;

            & > img {
                width: 100%;
                max-height: 95svh;
            }

            .close-button, 
            .map-container-wrapper{
                position: absolute;
            }

            .close-button{
                top: -2.5%;
                right: 4%;
                background-color: rgba(100,100,100,0.8);
                color: white;
                border-radius: 50px;
                padding: 4px;
                max-width: 5vw;
                min-width: 5vw;
                max-height: 5vw;
                min-height: 5vw;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .map-container-wrapper{
                top: 0%;
                left: 10%;
                width: 80%;
                height: 95%;
                display: flex;
                align-items: center;
                justify-content: center;

                max-height: 95svh;
            }

            .map-container{
                height: fit-content;
                position: relative;

                max-height: 90svh;
                overflow: hidden;

                display: grid;
                grid-template-rows: 3fr 2fr;

                .location-container{
                    
                    position: relative;
                    overflow: hidden;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    aspect-ratio: 843 / 440;
                    height: 100%;
                    max-width: 100%;
                    margin: auto;

                    & > img{
                        height: 100%;
                        max-width: 100%;
                        object-fit: contain;
                        margin: 0;
                        overflow: hidden;
                    }

                    :global(.zone-location-button){
                    }
                }

                .zone-select-text-buttons{
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    grid-template-rows: 1fr 1fr 1fr;
                    max-height: 400px;
                    margin: auto;
                    z-index: 1;
                }
            }
        }
    }
</style>